import { Box, CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { WhiteBox } from "@foodpilot/foods";
import { useTheme } from "@mui/material/styles";

export type SettingsLayoutProps = {
    title: string;
    isLoading?: boolean;
    isError?: boolean;
    children: React.ReactNode;
    topBar?: React.ReactNode;
};

export const SettingsLayout = (props: SettingsLayoutProps) => {
    const { title, isLoading, isError, children, topBar } = props;
    const theme = useTheme();

    return (
        <Stack direction="column" sx={{ m: theme.spacing(6), overflow: "hidden" }}>
            <WhiteBox sx={{ p: 0, borderRadius: theme.spacing(1.5) }}>
                <Box
                    sx={{
                        p: theme.spacing(2.75, 4),
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: { xs: theme.spacing(2), md: 0 },
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            order: { xs: 1, md: 1 },
                        }}
                    >
                        <Typography variant="h4">{title}</Typography>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "flex-start", md: "flex-end" },
                            width: { xs: "100%", md: "auto" },
                            order: { xs: 2, md: 2 },
                        }}
                    >
                        {topBar}
                    </Box>
                </Box>
                <Divider />
                <Box sx={{ p: theme.spacing(2.5, 3) }}>
                    {isLoading && (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                p: theme.spacing(2),
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    )}
                    {!isLoading && !isError && children}
                </Box>
            </WhiteBox>
        </Stack>
    );
};
